// language=GraphQL
export const ALL_BUSFINDER_BLOCKS_QUERY = `query Query {
  busfinderBlocks: cmsBusfinderBlocks {
    id
    title
  }
}`

// language=GraphQL
export const SINGLE_BUSFINDER_BLOCK_QUERY = `query Query($id: ID!) {
  busfinderBlock: cmsBusfinderBlock(id: $id) {
    id
    title
  }
}`

// language=GraphQL
export const CREATE_BUSFINDER_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsBusfinderBlockInput) {
    busfinderBlock: createCmsBusfinderBlock(input: $input) {
      id
      title
    }
  }`

// language=GraphQL
export const UPDATE_BUSFINDER_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsBusfinderBlockInput) {
    busfinderBlock: updateCmsBusfinderBlock(input: $input) {
      id
      title
    }
  }`

// language=GraphQL
export const DELETE_BUSFINDER_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsBusfinderBlockInput) {
    deleteCmsBusfinderBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_BUSFINDER_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsBusfinderBlockInput) {
    forceDeleteCmsBusfinderBlock(input: $input) {
      success
    }
  }`
